<template>
  <div class="layout--page" ref="layout">
    <header-block ref="header" />
    <main 
      ref="main"
      class="page" 
    >
      <div class="page__container">
        <slot />
      </div>
    </main>
    <footer-block ref="footer" />
  </div>
</template>

<script>
import HeaderBlock from "@/layouts/HeaderBlock";
import FooterBlock from "@/layouts/FooterBlock";

export default {
  name: "Page",

  components: { 
    HeaderBlock, 
    FooterBlock, 
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$root.$emit("page-loading", newValue);
      }
    },
  },

  created() {
    this.resizeThrottlerFunctionList.push(
      this.setMainOffset
    );
  },

  mounted() {
    this.setMainOffset()
  },

  methods: {
    setMainOffset() {
      const $main = this.$refs.main
      const height = this.$refs.header.$el.offsetHeight

      $main.style.marginTop = `${height}px`
    }
  },
};
</script>

<style lang="sass" scoped>
@import "../sass/variables"
@import "../sass/mixins"

.page
  +Size(100%)
  max-width: $sMWContainer
  flex-grow: 1

.page__container
  +PageLayoutContainer(false)
  padding: 
    top: 0
    bottom: 0
    left: 0
    right: 0

  @media screen and (min-width: 1200px)
    padding: 
      top: 0
      bottom: 0
      left: 0
      right: 0
</style>
